import React from "react";
import { Link } from "react-router-dom";
import { formatNumber } from "../../../../utils/utils";
import TableActionMenu from "../../../../components/table-action-menu/table-action-menu";

const ProjectGroupColumns = (companyData, navigate) => [
  {
    dataKey: "firestoreId",
    name: "ID",
    width: "10%",
    minWidth: "71px",
    align: "left",
    sortable: true,
  },
  {
    dataKey: "projectName",
    name: "Project Group Name",
    width: "10%",
    minWidth: "450px",
    align: "left",
    sortable: true,
    render: (value, rowData) => {
      return (
        <Link
          style={{ color: "inherit" }}
          to={`/projectsview/${rowData.firestoreId}/details?isGroupView=true`}
          target="_blank"
        >
          {value}
        </Link>
      );
    },
  },
  {
    dataKey: "client",
    name: "Client",
    width: "20%",
    minWidth: "305px",
    align: "left",
    sortable: true,
    render: (value) => {
      const companyName = companyData[value];
      return companyName ? (
        <Link
          style={{ color: "inherit" }}
          to={`/companiesview/${value}/details`}
        >
          {companyName}
        </Link>
      ) : (
        value
      );
    },
  },
  {
    dataKey: "projectLead",
    name: "Lead",
    width: "10%",
    minWidth: "180px",
    align: "left",
    sortable: true,
  },
  {
    dataKey: "dateCreated",
    name: "Created (mm/dd/yyyy)",
    width: "10%",
    minWidth: "180px",
    align: "left",
    sortable: true,
  },
  {
    dataKey: "financials_hours",
    name: "Hours (Act/Est)",
    width: "10%",
    minWidth: "180px",
    align: "left",
    render: (value, rowData) => {
      const actualHours = rowData.financials?.expense?.hours || 0;
      const budgetedHours = rowData.financials?.budget?.hours || 0;
      const color = actualHours <= budgetedHours ? "green" : "red";

      return (
        <span style={{ color }}>
          {formatNumber(actualHours)} hrs / {formatNumber(budgetedHours)} hrs
        </span>
      );
    },
  },
  {
    dataKey: "plannerServiceValue",
    name: "Estimated Service Value",
    width: "10%",
    minWidth: "180px",
    align: "left",
    render: (value) => `$ ${formatNumber(value)}`,
  },
  {
    dataKey: "materialValue",
    name: "Material Value",
    width: "10%",
    minWidth: "180px",
    align: "left",
    render: (value) => `$ ${formatNumber(value)}`,
  },
  {
    dataKey: "projectTotal",
    name: "Total Value",
    width: "10%",
    minWidth: "180px",
    align: "left",
    render: (value) => `$ ${formatNumber(value)}`,
  },
  {
    dataKey: "financials_actual_service_value",
    name: "Actual Service Value",
    width: "10%",
    minWidth: "200px",
    render: (value, rowData) => {
      const actualCost = rowData.financials?.expense?.cost || 0;
      const estimatedServiceValue = rowData.estimatedServiceValue || 0;
      const color = actualCost <= estimatedServiceValue ? "green" : "red";

      return <span style={{ color }}>$ {formatNumber(actualCost)}</span>;
    },
  },

  {
    dataKey: "financials_actual_service_value",
    name: "Total Cost",
    width: "10%",
    minWidth: "200px",
    render: (value, rowData) => {
      const actualCost = rowData.financials?.expense?.actualCost || 0;
      return <>$ {formatNumber(actualCost)}</>;
    },
  },
  {
    dataKey: "invoiceValue",
    name: "Total Invoiced Service Value",
    width: "10%",
    minWidth: "180px",
    align: "left",
    render: (value, rowData) => {
      return `$ ${formatNumber(rowData.invoiceValue)}`;
    },
  },
  {
    dataKey: "actions",
    name: "",
    width: "5%",
    minWidth: "10px",
    align: "center",
    render: (value, rowData) => {
      const menuOptions = [
        {
          title: "View Group Page",
          value: "groupView",
          onClick: () => {
            navigate(
              `/projectsview/${rowData.firestoreId}/details?isGroupView=true`
            );
          },
        },
      ];
      return <TableActionMenu noBorder width={150} options={menuOptions} />;
    },
  },
];

export default ProjectGroupColumns;
